<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="api_key != null"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            
            <v-text-field
                label="Label"
                v-model="api_key.label"
            />

            <v-switch
                label="Change secret"
                v-if="!create"
                v-model="change_secret"
            />

            <v-text-field
                label="Secret"
                v-model="api_key.plain_text_secret"
                hint="Minimum of 7 characters"
                v-if="change_secret"
            />


        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            create: false,
            api_key: null,
            change_secret: false,
        }
    },

    methods: {

        showDialog(api_key)
        {
            if ( api_key == null )
            {
                this.change_secret = true;
                this.create = true;
                this.api_key = {
                    'organization_id': this.$route.params.organization_id,
                    'credential_id': this.$rc.uuidv4(),
                    'label': 'New Credentials',
                    'plain_text_secret': null,
                    'app_id': this.$route.params.app_id,
                };
            }
            else
            {
                this.change_secret = false;
                this.create = false;
                this.api_key = _.cloneDeep(api_key);
                this.api_key.plain_text_secret = null;
            }

            this.dialog = true;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/app/store/my-apps/app-credential',
            
                'params' : this.api_key,
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('change');
                    },
            
                'on_error': 'Unable to save credentials',
            });

            
        },

        onCancel()
        {
            this.dialog = false;
        },
    },

    computed: {
        title() {
            return this.create ? 'Create New App Credentials' : 'Edit App Credentials';
        },

        is_valid()
        {
            if ( !this.change_secret ) 
                return true;

            return this.api_key != null && this.api_key.plain_text_secret != null && this.api_key.plain_text_secret.length > 7;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>